<template>
  <NuxtLayout name="default" shoppingSrc="/online-shopping/internet-phone/">
    <LazyHydrate when-idle>
      <!-- <NuxtImg
      sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
      width="1000"
      height="1000"
      format="webp"
      class="w-full"
      quality="100"
      src="img/banner/telecom-shopping.webp"
      alt=""
    /> -->
      <div class="mb-6">
        <SectionShoppingElementHeaderWizard :steps="steps" :current-step="currentStep" />
        <div class="gridClass bg-blue-200 my-10 p-6 laptop:p-16 rounded">
          <template v-if="currentStep === 1">
            <SectionShoppingPhoneFirst :refer="refer" @goToNextStep="currentStep = 2" />
          </template>
          <template v-if="currentStep === 2">
            <SectionShoppingPhoneSecond
              @goToNextStep="currentStep = 3"
              @goToPrevStep="currentStep = 1"
            />
          </template>
          <template v-if="currentStep === 3">
            <SectionShoppingPhoneThird
              @goToNextStep="currentStep = 4"
              @goToPrevStep="currentStep = 2"
            />
          </template>
        </div>
      </div>
    </LazyHydrate>
  </NuxtLayout>
</template>

<script setup>
definePageMeta({
  layout: false,
});

const router = useRouter();
const route = useRoute();
const steps = {
  1: { title: "مشخصات مشتری", fullTitle: "مرحله اول: مشخصات مشتری " },
  2: { title: "انتخاب خط و بسته", fullTitle: "مرحله دوم: انتخاب خط و بسته " },
  3: { title: "صورتحساب و پرداخت", fullTitle: "مرحله سوم: صورتحساب و پرداخت " },
  4: { title: "تایید پرداخت", fullTitle: "مرحله چهارم: تایید پرداخت " },
};

const currentStep = ref(+route.query.step || 1);
// const slug = ref(route.params.slug);

const goToSite = () => {
  router.push("/");
};

const refer = ref(null)

onMounted(() => {
  refer.value = window.history.state.back
});

watch(
  () => currentStep.value,
  async (newVal) => {
    window.scrollTo({
      top: 0,
    });
    if (route.query.step != newVal) {
      router.push({
        // path: `/online-shopping/${slug.value}`,
        path: `/online-shopping/internet-phone`,
        query: { step: newVal },
      });
    }
  }
);

watch(
  () => route.query.step,
  async (newVal) => {
    if (currentStep.value != newVal) {
      currentStep.value = +newVal;
    }
  }
);

useHead({
  link: [
    {
      rel: "canonical",
      // href: `https://navatel.ir/online-shopping/${slug.value}/`,
      href: `https://navatel.ir/online-shopping/internet-phone/`,
    },
  ],
});

onBeforeRouteLeave((to, from) => {
  useState("BundleId").value = null;
});
</script>
